import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import WindowResizeListener from 'common/components/WindowResizeListener';

import styles from './PageLayout.css';


class PageLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    dataId: PropTypes.string,
    title: PropTypes.string,
  };

  state = {
    overflow: false,
    height: 0,
  };

  render() {
    const {children, dataId, title} = this.props;
    const {overflow} = this.state;

    return (
      <div data-id={dataId} className={styles.root}>
        <div className={classNames(styles.title, {[styles.overflow]: overflow})}>{title}</div>
        <div
          className={styles.content}
          ref={el => {
            const newOverflow = el && el.scrollHeight > el.clientHeight;
            if (overflow !== newOverflow) this.setState({overflow: newOverflow});
          }}
        >
          <div style={{height: '100%'}}>
            {children}
            <WindowResizeListener
              onResize={(dimensions) => this.setState({height: dimensions.windowHeight})}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PageLayout;



// WEBPACK FOOTER //
// ./src/ondemand/components/PageLayout/PageLayout.js